import moment from 'moment';
import React from 'react';

import { IClub } from './../../store/player/clubs/store';

import ClubLogo from './../../assets/images/club-logo.svg';

interface IProps {
  club: IClub;
  date: string;
}

const AlertMessage = ({ club, date }: IProps): JSX.Element => (
  <div className="alert-message -standard">
    <div className="icon">
      <img
        src={(club && club.profileImage) || ClubLogo}
        alt="Alert icon"
      />
    </div>
    <div className="alert-message-content">
      <h4 className="title">Invitation To New Club</h4>
      <p className="text">{club.name}</p>
      <p className="date">{moment(date).format('ll')}</p>
    </div>
  </div>
);

export { AlertMessage };
